// Generated types for ConstraintDefinition
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { SysMLBehaviorReadAPI, SysMLBehaviorWriteAPI } from './sysmlbehavior';
import { SysMLBehaviorReadAPISchemaObject, SysMLBehaviorWriteAPISchemaObject } from './sysmlbehavior';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ConstraintDefinitionReadAPI extends SysMLBehaviorReadAPI {
}

export interface ConstraintDefinitionWriteAPI extends SysMLBehaviorWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ConstraintDefinitionReadAPISchema: z.ZodType<ConstraintDefinitionReadAPI> = SysMLBehaviorReadAPISchemaObject.extend({}).passthrough();

export const ConstraintDefinitionWriteAPISchema: z.ZodType<ConstraintDefinitionWriteAPI> = SysMLBehaviorWriteAPISchemaObject.extend({}).passthrough();
